import DataGrid from "./common/DataGrid";


const Accounts = () => {
return (
    <div style={{ height: '80vh' }}>
<DataGrid
  columnDefs={[{ field: 'account_number' }, { field: 'account_email' },{field : 'account_vendor'}]}
  apiEndpoint="https://oms-be.shreetradingcompany.in/api/all-accounts"
  height="80vh"
/>
</div>
)
}

export default Accounts;